import { Button } from "@mui/material";
import { FC, useContext } from "react";
import SelectModeBanner from "../SelectModeBanner";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import AddIcon from "@mui/icons-material/Add";
import { ModalContext } from "../../Modals";
import { basketService } from "../../../Core/Api/services";
import { AddItemToBasketRequest } from "../../../Core/Api/Types/add-item-to-basket-request";
import { SetItemsDirectivesRequest } from "../../../Core/Api/Types/set-items-directives-request";
import { BasketItemDirectives } from "../../../Core/Api/Types/basket-item-directives";
import DeleteIcon from "@mui/icons-material/Delete";
import useTrashActions from "../../../Utils/Hooks/useTrash";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { useTranslation } from "react-i18next";

export interface BrowsingSelectModeBannerProps {
  handleCloseClick: React.MouseEventHandler;
  itemsSelected?: DbAssetObjectInfos[];
  titleId?: string;
  nbItemSelected?: number;
}

const BrowsingSelectModeBanner: FC<BrowsingSelectModeBannerProps> = (props) => {
  const { t } = useTranslation();
  const { handleCloseClick, itemsSelected, titleId, nbItemSelected } = props;
  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };
  const trashActions = useTrashActions();

  const handleAddToCollectionClick = () => {
    if (!openModal) {
      return;
    }

    // MODAL WISHLIST
    /*
    const onClose: ModalAddToWishlistElementProps["onClose"] = (data) => {
      console.log(data);
    };

    openModal<ModalAddToWishlistElementProps>(ModalAddToWishlist, {
      onClose,
      mode: "add",
      items: Array()
        .fill("")
        .map((i, index) => ({ id: index })),
    });*/
  };

  const handleAddToBasketClick = () => {
    basketService.AddItemToBasket(new AddItemToBasketRequest({ objectId: parseInt(titleId!) }));
    var directivesList: BasketItemDirectives[] = [];
    itemsSelected?.forEach((element) => {
      directivesList.push(new BasketItemDirectives({ itemId: parseInt(titleId!), contentId: element.id }));
    });

    if (directivesList.length > 1) {
      var request: SetItemsDirectivesRequest = new SetItemsDirectivesRequest({ directives: directivesList });
      basketService.SetItemsDirectives(request);
    }
  };

  return (
    <SelectModeBanner
      text={t("banner:title.titlesSelected", { count: itemsSelected?.length || nbItemSelected })}
      onCloseClick={handleCloseClick}
    >
      <Button variant="whiteSoft" startIcon={<BookmarkBorderOutlinedIcon />} onClick={handleAddToCollectionClick}>
        {t("button:addToCollection_one")}
      </Button>
      <Button
        variant="outlined"
        color="error"
        startIcon={<DeleteIcon />}
        onClick={() => itemsSelected && trashActions.TrashObjectByIds(itemsSelected.map((x) => x.id))}
      >
        {t("common:delete")}
      </Button>
      <Button variant="white" startIcon={<AddIcon />} onClick={handleAddToBasketClick}>
        {t("button:addToOrder")}
      </Button>
    </SelectModeBanner>
  );
};

export default BrowsingSelectModeBanner;
